import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { motion } from 'framer-motion';
import { Utensils, Star, Clock, Heart } from 'lucide-react';
export function Restaurants() {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.5
  }} className="min-h-screen bg-white" data-id="element-491">
      <Header data-id="element-492" />

      <main className="pt-32 pb-24" data-id="element-493">
        <section className="max-w-7xl mx-auto px-6 mb-32 text-center" data-id="element-494">
          <span className="section-overline" data-id="element-495">Partnerships</span>
          <h1 className="text-[#4A0E0E] mb-8" data-id="element-496">Culinary Partners</h1>
          <p className="text-[#2C2C2C]/60 max-w-3xl mx-auto text-lg" data-id="element-497">
            We collaborate with the region's most celebrated chefs and
            restaurants to create bespoke dining experiences that elevate the
            art of the pairing.
          </p>
        </section>

        <section className="max-w-7xl mx-auto px-6 mb-32" data-id="element-498">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-499">
            <div className="h-[500px] rounded-3xl overflow-hidden" data-id="element-500">
              <img src="https://images.unsplash.com/photo-1516594915697-87eb3b1c14ea?auto=format&fit=crop&q=80&w=1000" alt="Fine Dining" className="w-full h-full object-cover" data-id="element-501" />
            </div>
            <div className="flex flex-col justify-center p-6" data-id="element-502">
              <h2 className="text-4xl font-serif text-[#4A0E0E] mb-8" data-id="element-503">
                A Symphony of Flavors
              </h2>
              <p className="text-[#2C2C2C]/70 mb-8 leading-relaxed" data-id="element-504">
                Our restaurant partnerships are built on a shared passion for
                quality, seasonality, and the perfect harmony between plate and
                glass. From pop-up dinners to permanent tasting menus, we bring
                the valley's best flavors to our members.
              </p>
              <div className="grid grid-cols-2 gap-8" data-id="element-505">
                <div data-id="element-506">
                  <h4 className="font-bold text-[#4A0E0E] mb-2 uppercase text-xs tracking-widest" data-id="element-507">
                    Chef Series
                  </h4>
                  <p className="text-sm text-[#2C2C2C]/60" data-id="element-508">
                    Exclusive monthly dinners featuring guest chefs.
                  </p>
                </div>
                <div data-id="element-509">
                  <h4 className="font-bold text-[#4A0E0E] mb-2 uppercase text-xs tracking-widest" data-id="element-510">
                    Tasting Menus
                  </h4>
                  <p className="text-sm text-[#2C2C2C]/60" data-id="element-511">
                    Curated wine flights paired with signature dishes.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-[#FDFCF0] py-32 px-6" data-id="element-512">
          <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-513">
            {[{
            icon: <Utensils data-id="element-514" />,
            title: 'Bespoke Menus',
            desc: "Customized dining experiences tailored to your group's preferences."
          }, {
            icon: <Star data-id="element-515" />,
            title: 'Michelin Standards',
            desc: 'Partnerships with award-winning culinary teams.'
          }, {
            icon: <Heart data-id="element-516" />,
            title: 'Local Sourcing',
            desc: 'Emphasis on farm-to-table ingredients from the valley.'
          }].map((item, idx) => <div key={idx} className="bg-white p-12 rounded-3xl border border-[#E6D5B8]/50 text-center shadow-sm" data-id="element-517">
                <div className="text-[#D4AF37] mb-6 flex justify-center" data-id="element-518">
                  {item.icon}
                </div>
                <h3 className="text-2xl font-serif text-[#4A0E0E] mb-4" data-id="element-519">
                  {item.title}
                </h3>
                <p className="text-[#2C2C2C]/60 text-sm leading-relaxed" data-id="element-520">
                  {item.desc}
                </p>
              </div>)}
          </div>
        </section>
      </main>

      <Footer data-id="element-521" />
    </motion.div>;
}